import React from "react";
import { Icon, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import NumberFormat from "../../../NumberFormat";
import { SeparateNumberFormat } from "../../../../services/utils";
import { getTotalPice } from "../../../../services/display";
import { AimSvg } from "../../../../images/customIcons/AimSvg";
import screenIcon from "../../../../images/screen-icon-white.svg";
import CartTableSummaryButtonHolder from "../styles/cartTableSummaryButtonStyle";

const AimIcon = (props) => <Icon component={AimSvg} {...props} />;

// Unique displays that report audience (mirrors CartAudienceComponent).
const countScreensMeasuringAudience = (displaysWithAudience) =>
  new Set((displaysWithAudience || []).map((d) => d.id)).size;


function CartTableSummaryButton({
  cart,
  audience,
  loadingAudience,
  programmatic,
  amountBudget,
  date_from,
  date_to,
  onClick,
}) {
  const { t } = useTranslation();

  if (!cart || cart.length === 0) return null;

  const price =
    programmatic === "programmatic"
      ? amountBudget
      : getTotalPice(cart, date_from, date_to);
  const currency = cart[0] && cart[0].price_currency;

  const hasAudience =
    audience &&
    Array.isArray(audience.displays_with_audience) &&
    audience.displays_with_audience.length > 0;

  return (
    <CartTableSummaryButtonHolder type="button" onClick={onClick}>
      <span className="summarySegment summaryPrice">
        <Icon type="shopping-cart" theme="outlined" />
        <NumberFormat value={price} currency={currency} include_currency={true} />
      </span>

      {/* Hidden below 1200px (see cartTableSummaryButtonStyle): only the
          price stays visible on narrow layouts. */}
      <div className="summaryExtra">
        <span className="summaryDivider" />
        {loadingAudience ? (
          <Icon type="loading" />
        ) : hasAudience ? (
          <React.Fragment>
            <Tooltip title={t("Impacts")}>
              <span className="summarySegment">
                <AimIcon />
                {SeparateNumberFormat(audience.total_impacts)}
              </span>
            </Tooltip>
            <Tooltip title={`${t("Screens measuring audience")}.`}>
              <span className="summarySegment">
                {countScreensMeasuringAudience(audience.displays_with_audience)}
                <Icon type="audit" theme="outlined" />
              </span>
            </Tooltip>
          </React.Fragment>
        ) : null}
        <Tooltip title={`${t("Total screens added in the campaign")}.`}>
          <span className="summarySegment">
            {cart.length}
            <img src={screenIcon} alt="" className="summaryScreenIcon" />
          </span>
        </Tooltip>
      </div>
    </CartTableSummaryButtonHolder>
  );
}

export default CartTableSummaryButton;
